import React, {FC} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface ConversationCardSubjectProps {
  subject: string;
}

/*
 * Styles.
 */

const StyledConvSubject = styled.div`
  grid-area: subject;

  color: ${(p) => p.theme.greys.shade90};
  font-weight: ${fontWeights.semibold};
  line-height: 18px;
  ${ellipsis()}
`;

/*
 * Component.
 */

export const ConversationCardSubject: FC<ConversationCardSubjectProps> = ({subject}) => (
  <StyledConvSubject>{subject}</StyledConvSubject>
);
